import React from 'react';
import {
  SectionGridContainer,
  GridContainer,
  CenterHeader,
} from './SectionGrid.style';
import DescriptionComponent from 'common/Description';
import CardInfo from 'common/components/Card/CardInfo';
import Box from '@mui/material/Box';
import Container from 'common/components/Container';
import { PrimaryLink } from 'containers/SaasModern/Banner/banner.style';
import { PrismicRichText } from '@prismicio/react';
import { Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import { CenterElement } from '../Acculturation/Acculturation.style';

const SectionGridComponent = ({ slice }) => {
  return (
    <Container>
      <SectionGridContainer>
        <CenterHeader>
          <PrismicRichText
            field={slice.primary.title}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="h2"
                  sx={(theme) => ({
                    color: '#111927',
                    fontSize: `${saasModernTheme.space[12]}px`,
                    fontFamily: saasModernTheme.fontFamily,
                    fontWeight: 'bold',
                    strong: {
                      background:
                        saasModernTheme.customColor.backgroundTextGradient,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                    [theme.breakpoints.down('sm')]: {
                      fontSize: `${saasModernTheme.space[8]}px`,
                    },
                  })}
                >
                  {children}
                </Typography>
              ),
            }}
          />
          <DescriptionComponent field={slice.primary.description} />
        </CenterHeader>
        <Box sx={{ marginTop: (theme) => theme.spacing(2) }}>
          <GridContainer columns={slice.primary.nbrelementcolumn}>
            {slice.items.map((item, index) => (
              <CardInfo
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
                icon2={item.icon_2}
                icon3={item.icon_3}
                type={slice.primary.type_card}
                plus={item.btnctaadd}
                indicator={item.indicator}
              />
            ))}
          </GridContainer>
        </Box>
      </SectionGridContainer>
      {slice.primary.cta && (
        <CenterElement>
          <PrimaryLink href={slice.primary.cta_link}>
            {slice.primary.cta}
          </PrimaryLink>

          {slice.primary.cta_button_android && (
            <PrimaryLink href={slice.primary.cta_link_button_android}>
              {slice.primary.cta_button_android}
            </PrimaryLink>
          )}
        </CenterElement>
      )}
    </Container>
  );
};

export default SectionGridComponent;
